module.exports = __webpack_public_path__ + "static/Swiss721-Medium-f531da8ede6aa8b959af2cf39098a6fc.woff";